import { BasePageModel } from './index';

export enum FrameType {
  intent = 'intent',
  composite = 'composite',
  entity = 'entity',
  service = 'service',
  generic = 'generic_type',
  external = 'external_type',
  dialogAct = 'dialog_act'
}

export type FrameItem = BasePageModel & {
  type: FrameType;
};

export const FrameItemToLocal = (data: any) => {
  return {
    id: data.frame.id,
    name: data.frame.name,
    type: data.frame.type,
    attributes: data.attributes,
    state: data.state
  };
};
